import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import api from "../lib/api";
import { useWishlist } from "../lib/wishlist";
import ProductCard from "../components/ProductCard";

export default function WishlistPage() {
  const { ids, count, clear } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products")
      .then(({ data }) => setProducts(data))
      .finally(() => setLoading(false));
  }, []);

  const items = products.filter((p) => ids.includes(p.id));

  return (
    <div data-testid="wishlist-page" className="min-h-screen bg-[#FAFBFD]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        {/* Header */}
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <span className="welljio-eyebrow">Saved for later</span>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.035em] leading-[1.0] mt-4 text-welljio-ink">
              Your <span className="italic font-normal text-welljio-accent">wishlist</span>
              {count > 0 && <span className="text-welljio-coral"> · {count}</span>}
            </h1>
          </div>
          {count > 0 && (
            <button
              data-testid="wishlist-clear-button"
              onClick={clear}
              className="text-sm text-welljio-muted hover:text-welljio-coral underline underline-offset-[5px] decoration-welljio-muted/30 hover:decoration-welljio-coral"
            >
              Clear wishlist
            </button>
          )}
        </div>

        {/* Body */}
        {loading ? (
          <p className="text-welljio-muted">Loading…</p>
        ) : items.length === 0 ? (
          <div data-testid="wishlist-empty-state" className="welljio-premium-card text-center py-16 px-6">
            <div className="w-14 h-14 rounded-2xl bg-welljio-coralSoft mx-auto flex items-center justify-center mb-5">
              <Heart className="w-6 h-6 text-welljio-coral" strokeWidth={1.4} />
            </div>
            <h2 className="font-heading text-2xl font-semibold text-welljio-ink mb-2">Nothing saved yet</h2>
            <p className="text-welljio-muted max-w-md mx-auto mb-7">
              Tap the heart on any product to save it here — handy for comparing your picks before you decide.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <Link to="/shop" data-testid="wishlist-shop-link" className="welljio-btn-primary">
                <ShoppingBag className="w-4 h-4" strokeWidth={1.6} />
                Browse the collection
              </Link>
              <Link to="/find-my-fit" className="text-sm font-medium text-welljio-accent hover:text-welljio-coral underline underline-offset-[6px] decoration-welljio-accent/30 hover:decoration-welljio-coral">
                Find my fit →
              </Link>
            </div>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((p, i) => (
              <ProductCard product={p} key={p.id} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
